import React from 'react';
import HeaderLogo from './HeaderLogo';

const MainHeaderLogo = (props) => <HeaderLogo {...props} />;

export default MainHeaderLogo;
